import EcoSpace from 'eco-design/base/eco-space';
import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const H: React.FC = () => {
    const { t } = useLang('shp3.H');
    const [enter, setEnter] = useState(false);
    const webpOrJpg = useWebpOrJpg('#shp3-H');
    /** 动画 */
    const infoRef = useRef<HTMLDivElement>(null);
    const playRef = useRef<HTMLDivElement>(null);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const handlePlay = () => {
        if (!playRef.current) return;
        const element = playRef.current;
        // 从头开始
        element.scrollTop = 0;
        const duration = 2000; // 2s
        const start = element.scrollTop;
        const end = element.scrollHeight - element.clientHeight;
        const startTime = performance.now();

        const animate = (time: number) => {
            const elapsed = time - startTime;
            let progress = Math.min(elapsed / duration, 1); // 0~1
            // 简单线性滚动（可以改成缓动函数）
            element.scrollTop = start + (end - start) * progress;

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    };
    useEffect(() => {
        const title = infoRef.current?.querySelector('.title');
        const desc = infoRef.current?.querySelector('.desc');
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                }
            },
        });
        const ani2 = AniContainer.create({
            triggerElement: '#shp3-H',
            triggerHook: 1,
            offset: '70%',
            ducration: '20%',
            onEnter: () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
                timerRef.current = setTimeout(handlePlay, 1000);
                setEnter(true);
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    setEnter(false);
                    if (playRef.current) {
                        playRef.current.scrollTop = 0;
                    }
                    if (timerRef.current) {
                        clearTimeout(timerRef.current);
                    }
                }
            },
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
        };
    }, []);
    return (
        <>
            {/* {typeof window !== 'undefined' && window.innerWidth < 1024 && <EcoSpace />} */}
            <EcoSpace className={css.space1} />
            <section className={`${css.section} shp3-H GtmModuleData-section`} id="shp3-H" data-section-id={'shp3-H'} data-section-title={t('title')}>
                <div className="sticky">
                    <div className="info" ref={infoRef}>
                        <div className="title ani-1">
                            {t.rich('title', {
                                sub: (i: string) => <span className="sub">{i}</span>,
                            })}
                        </div>
                        <div className="desc ani-2">{t('desc')}</div>
                    </div>

                    <div className={`ani-container ${enter ? 'enter' : ''}`}>
                        <div className="item">
                            <EcoImg className="head-img head-img-1" pc={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758856863388/head1.png')} />
                            <div className="left-chat">SOC at 50%, with a 10-hour power outage imminent. Can you provide a power outage endurance report?</div>
                        </div>
                        <div className="phone">
                            <div className="phone-box" ref={playRef}>
                                <img
                                    src={webpOrJpg(
                                        'https://websiteoss.ecoflow.com/upload/image/1759203082705/20250919-163527%20(1).jpg',
                                        'https://websiteoss.ecoflow.com/upload/image/1759203192492/20250919-163527.webp',
                                    )}
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="item">
                            <EcoImg className="head-img head-img-2" pc={webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1758856863080/head2.svg')} />
                            <div className="right-chat right-chat-1">
                                Current Battery Capacity: 350.0 kWh. At the current usage rate, power can be sustained for 11.0 hours. Projected Solar
                                Generation: 1.97 kWh during the outage.
                            </div>
                            <div className="right-chat right-chat-2">
                                Recommendations:
                                <br></br>1. Disconnect high-power appliances to extend backup duration.
                                <br></br>2. Maintain lower hourly power usage to optimize efficiency. With careful planning, stored energy plus solar can cover
                                your needs during the outage.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default H;
